import { render, staticRenderFns } from "./FeiShuEventDetail.vue?vue&type=template&id=c53acffe&scoped=true"
import script from "./FeiShuEventDetail.vue?vue&type=script&lang=js"
export * from "./FeiShuEventDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c53acffe",
  null
  
)

export default component.exports